var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyAndPaste(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 470.053,
    height: 414,
    viewBox: "0 0 470.053 414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1315",
    x: 0,
    y: 68.005,
    width: 422.107,
    height: 329.399,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 50,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy-and-paste",
    transform: "translate(-129.947 -971)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1246",
    "data-name": "Rectangle 1246",
    width: 468,
    height: 414,
    transform: "translate(132 971)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(132 971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    d: "M516.7,257.891s-7.131-.519-6.472,15.483,2.284,24.519,2.284,24.519-.206,3.545-2.96,2.853-7.915-4.122-10.462-1.575-1.707,6.785,1.806,11.616,10.817,15.714,11.468,16.7.907,2.778-1.039,2.605-15.1-4.633-16.835,1.731,10.256,18.228,11.542,19.548,1.352,2.16.824,2.96-4.8-1.113-8.591-2.226-8.385-1.748-9.069,2.012,4.584,14.749,24.37,26.3l9.522,4.749,9-5.771c18.533-13.471,22.689-24.931,21.625-28.6s-5.573-2.589-9.234-1.1-7.725,3.817-8.327,3.075-.61-1.583.536-3.026,11.9-14.444,9.531-20.611-15-.412-16.926-.041-1.847-1.467-1.3-2.473,6.736-12.6,9.745-17.767,3.537-9.341.635-11.732-7.593,1.649-10.256,2.605-3.224-2.539-3.224-2.539.767-8.648-.181-24.626-8.162-14.692-8.162-14.692",
    transform: "translate(-85.873 -45.268)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    d: "M523.25,275.27a2.8,2.8,0,0,1,0,.338c0,.239.041.561.074.981.058.882.148,2.152.256,3.776.223,3.3.5,8.03.824,13.9.651,11.748,1.418,27.973,2.2,45.9s1.5,34.157,2.086,45.9c.3,5.862.544,10.611.709,13.908.082,1.649.148,2.9.19,3.784v.981a5.352,5.352,0,0,0-.074-.981c-.058-.882-.148-2.152-.256-3.776-.223-3.3-.5-8.03-.824-13.9-.651-11.74-1.418-27.973-2.2-45.9s-1.5-34.148-2.086-45.9c-.3-5.862-.544-10.6-.709-13.908-.083-1.649-.148-2.894-.19-3.776V275.27Z",
    transform: "translate(-91.861 -48.326)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    d: "M509.74,314.18a3.5,3.5,0,0,1,.594.495c.363.338.882.824,1.509,1.451,1.253,1.245,2.943,3.009,4.774,5l4.658,5.087c.552.6,1.022,1.121,1.418,1.542a3.7,3.7,0,0,1,.495.585,3.294,3.294,0,0,1-.6-.486c-.363-.338-.874-.824-1.5-1.459-1.245-1.261-2.91-3.042-4.732-5.029l-4.691-5.054-1.426-1.533A2.777,2.777,0,0,1,509.74,314.18Z",
    transform: "translate(-89.489 -55.157)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    d: "M527.19,327.587c-.066-.074,3.413-3.718,7.775-8.137s7.964-7.964,8.038-7.89-3.413,3.718-7.775,8.145S527.264,327.636,527.19,327.587Z",
    transform: "translate(-92.552 -54.697)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2465",
    "data-name": "Path 2465",
    d: "M527.14,362.213a3.545,3.545,0,0,1,.668-.429l1.863-1.039c1.566-.882,3.735-2.111,6.076-3.553s4.419-2.8,5.919-3.8l1.773-1.187a3.672,3.672,0,0,1,.676-.4,2.972,2.972,0,0,1-.594.519c-.4.313-.973.75-1.707,1.278-1.468,1.064-3.529,2.473-5.878,3.908s-4.543,2.638-6.142,3.463c-.824.412-1.459.734-1.921.948a4.12,4.12,0,0,1-.734.3Z",
    transform: "translate(-92.544 -61.761)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2466",
    "data-name": "Path 2466",
    d: "M508,352.72a2.857,2.857,0,0,1,.66.305l1.723.965c1.451.824,3.438,1.979,5.623,3.3s4.122,2.473,5.573,3.372c.7.437,1.278.824,1.649,1.055a2.708,2.708,0,0,1,.585.437,3,3,0,0,1-.66-.313c-.412-.214-1-.544-1.723-.956-1.451-.824-3.438-1.987-5.631-3.3s-4.122-2.473-5.565-3.38c-.709-.437-1.278-.824-1.649-1.055A2.949,2.949,0,0,1,508,352.72Z",
    transform: "translate(-89.183 -61.923)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2467",
    "data-name": "Path 2467",
    d: "M504.22,382.25a4.2,4.2,0,0,1,.824.4l2.218,1.22c1.863,1.047,4.419,2.473,7.239,4.122s5.359,3.141,7.189,4.238l2.135,1.352a3.946,3.946,0,0,1,.767.528,5.258,5.258,0,0,1-.824-.4l-2.209-1.228c-1.863-1.039-4.427-2.473-7.239-4.122s-5.359-3.141-7.189-4.246l-2.16-1.319A5.771,5.771,0,0,1,504.22,382.25Z",
    transform: "translate(-88.52 -67.107)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2468",
    "data-name": "Path 2468",
    d: "M528.48,393.2a4.55,4.55,0,0,1,.824-.561l2.317-1.4c1.946-1.2,4.642-2.844,7.56-4.749s5.532-3.693,7.42-5l2.226-1.542a5.691,5.691,0,0,1,.824-.536,5.065,5.065,0,0,1-.758.651c-.5.4-1.237.956-2.16,1.649-1.838,1.36-4.419,3.191-7.354,5.1s-5.639,3.529-7.634,4.658c-.989.569-1.806,1.014-2.374,1.311A5.575,5.575,0,0,1,528.48,393.2Z",
    transform: "translate(-92.779 -66.608)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2469",
    "data-name": "Path 2469",
    d: "M540.223,416.06H513.89l8.591,65.057h9.143Z",
    transform: "translate(-90.217 -73.043)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2470",
    "data-name": "Path 2470",
    d: "M515.54,425.195s0,.091.148.231a1.533,1.533,0,0,0,.635.453,3.183,3.183,0,0,0,2.778-.338c1.063-.585,1.987-1.74,3.413-2.251a7.511,7.511,0,0,1,4.84.1,20.827,20.827,0,0,1,4.51,2.185,31.854,31.854,0,0,0,3.669,1.97,10.3,10.3,0,0,0,2.7.775,5.053,5.053,0,0,0,.767.058h.264a13.626,13.626,0,0,1-3.611-1.088,35.856,35.856,0,0,1-3.586-2.028A19.962,19.962,0,0,0,527.486,423a7.775,7.775,0,0,0-5.112-.058,6.6,6.6,0,0,0-1.921,1.2,15.933,15.933,0,0,1-1.509,1.163,3.067,3.067,0,0,1-2.564.445,2.622,2.622,0,0,1-.841-.552Z",
    transform: "translate(-90.507 -74.18)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2471",
    "data-name": "Path 2471",
    d: "M516.709,439.284a8.837,8.837,0,0,1,.618-.7,5.845,5.845,0,0,1,2.1-1.336,9.473,9.473,0,0,1,3.669-.552,38.994,38.994,0,0,1,4.576.627,15.665,15.665,0,0,0,4.691.19,12.752,12.752,0,0,0,3.693-1.047,12.08,12.08,0,0,0,2.218-1.319,3.562,3.562,0,0,0,.709-.635,24.017,24.017,0,0,1-3.05,1.649,13.449,13.449,0,0,1-3.611.94,16.184,16.184,0,0,1-4.576-.231,36.519,36.519,0,0,0-4.642-.594,9.168,9.168,0,0,0-3.784.668,5.572,5.572,0,0,0-2.119,1.5,4.048,4.048,0,0,0-.4.585C516.734,439.193,516.693,439.275,516.709,439.284Z",
    transform: "translate(-90.712 -76.282)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2472",
    "data-name": "Path 2472",
    d: "M538.051,447.692a2.012,2.012,0,0,0-.725-.379,7.6,7.6,0,0,0-2.185-.47,13.8,13.8,0,0,0-3.3.19c-1.228.2-2.547.536-3.924.824a16.946,16.946,0,0,1-3.924.445,8.839,8.839,0,0,1-3.116-.676,7.319,7.319,0,0,1-2.358-1.756,1.945,1.945,0,0,0,.445.684,5.531,5.531,0,0,0,1.789,1.344,8.417,8.417,0,0,0,3.224.824A15.766,15.766,0,0,0,528,448.3c1.4-.3,2.7-.643,3.908-.866a15.588,15.588,0,0,1,3.215-.272A11.539,11.539,0,0,1,538.051,447.692Z",
    transform: "translate(-91.03 -78.276)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2473",
    "data-name": "Path 2473",
    d: "M519.53,458.675a4.246,4.246,0,0,1,2.556-.256,12.259,12.259,0,0,1,2.68,1,10.149,10.149,0,0,0,3.471.956,10.4,10.4,0,0,0,6.3-1.459A8.439,8.439,0,0,0,536.1,457.7c.322-.338.486-.536.462-.552a23.778,23.778,0,0,1-2.177,1.5,10.777,10.777,0,0,1-6.109,1.294c-2.473-.14-4.411-1.649-6.142-1.83a4.007,4.007,0,0,0-1.987.173,1.294,1.294,0,0,0-.618.387Z",
    transform: "translate(-91.208 -80.256)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2474",
    "data-name": "Path 2474",
    d: "M521.31,473.4a5.071,5.071,0,0,0,2.193-.437c1.327-.445,2.968-1.459,4.881-2.218a7.726,7.726,0,0,1,2.795-.585,5.1,5.1,0,0,1,2.251.511,4.947,4.947,0,0,1,1.649,1.4,1.037,1.037,0,0,0-.247-.552,3.736,3.736,0,0,0-1.237-1.121,5.17,5.17,0,0,0-2.383-.635,7.744,7.744,0,0,0-2.96.577c-1.979.824-3.57,1.839-4.831,2.333S521.3,473.322,521.31,473.4Z",
    transform: "translate(-91.52 -82.47)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2475",
    "data-name": "Path 2475",
    d: "M522.88,481.207a6.047,6.047,0,0,0,1.649.544,28.857,28.857,0,0,0,4.163.7,29.931,29.931,0,0,0,4.229.124,5.942,5.942,0,0,0,1.74-.206c0-.132-2.671,0-5.919-.346S522.913,481.083,522.88,481.207Z",
    transform: "translate(-91.796 -84.477)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2476",
    "data-name": "Path 2476",
    d: "M359.569,202.37l50.753,28.1-1.9,3.586L358.11,205.42l1.459-3.05",
    transform: "translate(-62.869 -35.528)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2477",
    "data-name": "Path 2477",
    d: "M356.85,198.38l2.333-3.57,1.36.841-2.094,3.6Z",
    transform: "translate(-62.648 -34.2)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2478",
    "data-name": "Path 2478",
    d: "M412.34,231.07l2.605,1.5-8.5,54.232-4.015.049Z",
    transform: "translate(-70.65 -40.566)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2479",
    "data-name": "Path 2479",
    d: "M388.24,304.285s6.183-6.266,14.477-5.771a17.973,17.973,0,0,1,12.54,5.771Z",
    transform: "translate(-68.159 -52.402)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2480",
    "data-name": "Path 2480",
    d: "M352.63,223.153l-20.1-11.608L338.3,201.5a11.6,11.6,0,0,1,15.846-4.254h0a11.608,11.608,0,0,1,4.246,15.854Z",
    transform: "translate(-58.378 -34.356)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1247",
    "data-name": "Rectangle 1247",
    width: 64.389,
    height: 3.133,
    transform: "translate(178.731 249.229) rotate(180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2481",
    "data-name": "Path 2481",
    d: "M218.437,292.652l12.078-45.262H180.232L169.3,292.652Z",
    transform: "translate(-29.722 -43.431)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2482",
    "data-name": "Path 2482",
    d: "M172.95,289.676h44.916L228.32,249.93H183.173Z",
    transform: "translate(-30.363 -43.877)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1248",
    "data-name": "Rectangle 1248",
    width: 3.248,
    height: 155.259,
    transform: "translate(101.58 258.496)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1249",
    "data-name": "Rectangle 1249",
    width: 3.248,
    height: 154.814,
    transform: "translate(104.836 258.941)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1250",
    "data-name": "Rectangle 1250",
    width: 3.248,
    height: 155.259,
    transform: "translate(301.927 258.496)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1251",
    "data-name": "Rectangle 1251",
    width: 3.248,
    height: 154.814,
    transform: "translate(305.184 258.941)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1252",
    "data-name": "Rectangle 1252",
    width: 247.011,
    height: 12.738,
    transform: "translate(87.548 249.476)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1253",
    "data-name": "Rectangle 1253",
    width: 108.744,
    height: 21.081,
    transform: "translate(194.816 262.214)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2483",
    "data-name": "Path 2483",
    d: "M307.1,328.544a2.424,2.424,0,1,1-2.424-2.424A2.424,2.424,0,0,1,307.1,328.544Z",
    transform: "translate(-53.062 -57.253)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2484",
    "data-name": "Path 2484",
    d: "M84.862,388.53h42.714a5.441,5.441,0,0,0,5.441-5.441V369.9a9.168,9.168,0,0,0-9.176-9.168H84.54Z",
    transform: "translate(-14.842 -63.329)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2485",
    "data-name": "Path 2485",
    d: "M117.108,402.734H33.122A4.122,4.122,0,0,1,29,398.612h0a4.122,4.122,0,0,1,4.122-4.122h83.986a4.122,4.122,0,0,1,4.122,4.122h0a4.122,4.122,0,0,1-4.122,4.122Z",
    transform: "translate(-5.091 -69.256)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2486",
    "data-name": "Path 2486",
    d: "M10.917,260.534l46.169-.824L86.419,370.556l-62.509.627L.314,274.014a10.907,10.907,0,0,1,10.6-13.48Z",
    transform: "translate(-0.001 -45.594)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2487",
    "data-name": "Path 2487",
    d: "M38.206,404.49,24.38,484.832h3.792L46.343,404.49Z",
    transform: "translate(-4.28 -71.011)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2488",
    "data-name": "Path 2488",
    d: "M77.562,404.49,62.87,484.832h3.784L85.7,404.49Z",
    transform: "translate(-11.037 -71.011)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2489",
    "data-name": "Path 2489",
    d: "M122.677,404.49l16.39,80.342h-3.792L114.54,404.49Z",
    transform: "translate(-20.108 -71.011)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2490",
    "data-name": "Path 2490",
    d: "M62.87,259.71,85.732,370.672h17.536L84.932,272.629A15.788,15.788,0,0,0,69.408,259.71Z",
    transform: "translate(-11.037 -45.594)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2491",
    "data-name": "Path 2491",
    d: "M256.367,0V52.97H180.287L177.55.371Z",
    transform: "translate(-31.17)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1254",
    "data-name": "Rectangle 1254",
    width: 52.492,
    height: 76.08,
    transform: "translate(146.371 52.863) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2492",
    "data-name": "Path 2492",
    d: "M253.907,53.218h-76.8V0h76.8ZM177.844,52.5h75.362V.734H177.844Z",
    transform: "translate(-31.093)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1255",
    "data-name": "Rectangle 1255",
    width: 59.599,
    height: 39.45,
    transform: "translate(154.616 6.892)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2493",
    "data-name": "Path 2493",
    d: "M247.076,8.323H242.64l-12.284.049-42.871.082.173-.173V47.723h0l-.19-.181h59.6l-.148.148c0-12,.058-21.839.082-28.7v-8c0,1.83,0,4.493.041,7.906,0,6.876.041,16.753.074,28.79v.157H187.18v-.082h0V8.15h.173l43.019.082,12.243.049h4.064Z",
    transform: "translate(-32.861 -1.431)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2494",
    "data-name": "Path 2494",
    d: "M177.55.27a6.744,6.744,0,0,1,1.3.824c.824.561,1.838,1.36,2.984,2.275s2.152,1.781,2.861,2.473a5.855,5.855,0,0,1,1.088,1.113,51.479,51.479,0,0,1-4.18-3.257A40.4,40.4,0,0,1,177.55.27Z",
    transform: "translate(-31.17 -0.047)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2495",
    "data-name": "Path 2495",
    d: "M268.08.45a37.539,37.539,0,0,1-3.982,3.4,36.142,36.142,0,0,1-4.238,3.116,36.552,36.552,0,0,1,4.007-3.4A36.142,36.142,0,0,1,268.08.45Z",
    transform: "translate(-45.62 -0.079)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2496",
    "data-name": "Path 2496",
    d: "M267.944,62.656,259.46,55.78",
    transform: "translate(-45.55 -9.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2497",
    "data-name": "Path 2497",
    d: "M259.46,55.78a40.22,40.22,0,0,1,4.361,3.3,40.785,40.785,0,0,1,4.122,3.578,40.4,40.4,0,0,1-4.361-3.3A39.06,39.06,0,0,1,259.46,55.78Z",
    transform: "translate(-45.55 -9.793)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2498",
    "data-name": "Path 2498",
    d: "M177.55,62.737a36.729,36.729,0,0,1,3.957-3.372,35.451,35.451,0,0,1,4.2-3.075,35.329,35.329,0,0,1-3.966,3.372A36.608,36.608,0,0,1,177.55,62.737Z",
    transform: "translate(-31.17 -9.882)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1256",
    "data-name": "Rectangle 1256",
    width: 13.208,
    height: 37.504,
    transform: "translate(166.719 32.392) rotate(-90)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1257",
    "data-name": "Rectangle 1257",
    width: 68.503,
    height: 113.394,
    transform: "translate(366.844 24.313)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1258",
    "data-name": "Rectangle 1258",
    width: 68.503,
    height: 113.394,
    transform: "translate(364.56 24.313)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1259",
    "data-name": "Rectangle 1259",
    width: 62.674,
    height: 108.793,
    transform: "translate(367.479 26.613)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1260",
    "data-name": "Rectangle 1260",
    width: 38.534,
    height: 80.523,
    transform: "translate(379.408 40.744)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2499",
    "data-name": "Path 2499",
    d: "M460.2,106.2c-.082-7.519,6.678-14.84,14.123-15.912,3.553-.5,7.329.2,10.644-1.162,5.928-2.424,7.816-10.3,13.776-12.63l.272,58.2H460.2Z",
    transform: "translate(-80.792 -13.43)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1261",
    "data-name": "Rectangle 1261",
    width: 2.366,
    height: 21.114,
    transform: "translate(8.714 92.412)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1262",
    "data-name": "Rectangle 1262",
    width: 2.366,
    height: 21.114,
    transform: "translate(86.484 92.412)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1263",
    "data-name": "Rectangle 1263",
    width: 98.892,
    height: 8.492,
    transform: "translate(0 83.928)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1264",
    "data-name": "Rectangle 1264",
    width: 13.636,
    height: 63.548,
    transform: "translate(65.725 20.38)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2500",
    "data-name": "Path 2500",
    d: "M90.448,82.721a2.7,2.7,0,1,1-.786-1.923A2.7,2.7,0,0,1,90.448,82.721Z",
    transform: "translate(-14.929 -14.045)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1265",
    "data-name": "Rectangle 1265",
    width: 4.172,
    height: 25.97,
    transform: "translate(70.613 37.215)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1266",
    "data-name": "Rectangle 1266",
    width: 13.636,
    height: 63.548,
    transform: "translate(51.874 20.38)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2501",
    "data-name": "Path 2501",
    d: "M73.638,82.721a2.7,2.7,0,1,1-.781-1.922,2.7,2.7,0,0,1,.781,1.922Z",
    transform: "translate(-11.978 -14.045)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1267",
    "data-name": "Rectangle 1267",
    width: 4.172,
    height: 25.97,
    transform: "translate(56.763 37.215)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1268",
    "data-name": "Rectangle 1268",
    width: 13.636,
    height: 63.548,
    transform: "translate(38.683 20.38)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2502",
    "data-name": "Path 2502",
    d: "M57.648,82.721a2.7,2.7,0,1,1-.786-1.923A2.7,2.7,0,0,1,57.648,82.721Z",
    transform: "translate(-9.171 -14.045)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1269",
    "data-name": "Rectangle 1269",
    width: 4.172,
    height: 25.97,
    transform: "translate(43.572 37.215)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2503",
    "data-name": "Path 2503",
    d: "M25.178,88.189,41.56,32.283,35.912,29.81,19.11,86.161Z",
    transform: "translate(-3.355 -5.233)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1270",
    "data-name": "Rectangle 1270",
    width: 272.107,
    height: 179.399,
    transform: "translate(129.116 168.203)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1271",
    "data-name": "Rectangle 1271",
    width: 267.375,
    height: 162.077,
    transform: "translate(131.449 181.633)",
    fill: "#352628"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1272",
    "data-name": "Rectangle 1272",
    width: 264.267,
    height: 159.538,
    transform: "translate(133.007 182.902)",
    fill: "#443637"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1273",
    "data-name": "Rectangle 1273",
    width: 10.52,
    height: 6.274,
    transform: "translate(152.645 195.071)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1274",
    "data-name": "Rectangle 1274",
    width: 59.508,
    height: 6.274,
    transform: "translate(167.477 195.071)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1275",
    "data-name": "Rectangle 1275",
    width: 38.889,
    height: 6.274,
    transform: "translate(237.077 195.071)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1276",
    "data-name": "Rectangle 1276",
    width: 39.961,
    height: 6.274,
    transform: "translate(162.531 206.226)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1277",
    "data-name": "Rectangle 1277",
    width: 36.35,
    height: 6.274,
    transform: "translate(206.012 218.766)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1278",
    "data-name": "Rectangle 1278",
    width: 36.35,
    height: 6.274,
    transform: "translate(249.625 218.766)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1279",
    "data-name": "Rectangle 1279",
    width: 6.579,
    height: 6.274,
    transform: "translate(292.158 218.766)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1280",
    "data-name": "Rectangle 1280",
    width: 10.536,
    height: 6.274,
    transform: "translate(303.848 218.766)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1281",
    "data-name": "Rectangle 1281",
    width: 54.999,
    height: 6.274,
    transform: "translate(265.223 206.226)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1282",
    "data-name": "Rectangle 1282",
    width: 45.971,
    height: 6.274,
    transform: "translate(209.796 206.226)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1283",
    "data-name": "Rectangle 1283",
    width: 54.999,
    height: 6.274,
    transform: "translate(174.988 229.69)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1284",
    "data-name": "Rectangle 1284",
    width: 15.895,
    height: 6.274,
    transform: "translate(174.988 241.149)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1285",
    "data-name": "Rectangle 1285",
    width: 27.924,
    height: 6.274,
    transform: "translate(197.767 241.149)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1286",
    "data-name": "Rectangle 1286",
    width: 21.048,
    height: 6.274,
    transform: "translate(237.291 241.149)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1287",
    "data-name": "Rectangle 1287",
    width: 21.048,
    height: 6.274,
    transform: "translate(263.508 241.149)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1288",
    "data-name": "Rectangle 1288",
    width: 27.495,
    height: 6.274,
    transform: "translate(193.464 253.021)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1289",
    "data-name": "Rectangle 1289",
    width: 88.512,
    height: 6.274,
    transform: "translate(224.405 253.021)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1290",
    "data-name": "Rectangle 1290",
    width: 27.495,
    height: 6.274,
    transform: "translate(174.988 264.902)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1291",
    "data-name": "Rectangle 1291",
    width: 13.743,
    height: 6.274,
    transform: "translate(207.644 264.902)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1292",
    "data-name": "Rectangle 1292",
    width: 48.988,
    height: 6.274,
    transform: "translate(228.7 264.902)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1293",
    "data-name": "Rectangle 1293",
    width: 15.038,
    height: 6.274,
    transform: "translate(196.902 276.782)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1294",
    "data-name": "Rectangle 1294",
    width: 6.447,
    height: 6.274,
    transform: "translate(217.092 276.782)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1295",
    "data-name": "Rectangle 1295",
    width: 16.753,
    height: 6.274,
    transform: "translate(231.709 276.782)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1296",
    "data-name": "Rectangle 1296",
    width: 39.961,
    height: 6.274,
    transform: "translate(253.194 276.782)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1297",
    "data-name": "Rectangle 1297",
    width: 20.191,
    height: 6.274,
    transform: "translate(298.737 276.782)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1298",
    "data-name": "Rectangle 1298",
    width: 61.866,
    height: 6.274,
    transform: "translate(324.088 276.782)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1299",
    "data-name": "Rectangle 1299",
    width: 27.495,
    height: 6.274,
    transform: "translate(196.902 288.654)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1300",
    "data-name": "Rectangle 1300",
    width: 18.476,
    height: 6.274,
    transform: "translate(232.996 288.654)",
    fill: "#c3c640"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1301",
    "data-name": "Rectangle 1301",
    width: 18.476,
    height: 6.274,
    transform: "translate(258.776 288.654)",
    fill: "#c3c640"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1302",
    "data-name": "Rectangle 1302",
    width: 69.171,
    height: 6.274,
    transform: "translate(196.902 300.534)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1303",
    "data-name": "Rectangle 1303",
    width: 36.515,
    height: 6.274,
    transform: "translate(272.099 300.534)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1304",
    "data-name": "Rectangle 1304",
    width: 27.495,
    height: 6.274,
    transform: "translate(174.988 312.414)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1305",
    "data-name": "Rectangle 1305",
    width: 19.77,
    height: 6.274,
    transform: "translate(209.796 312.414)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1306",
    "data-name": "Rectangle 1306",
    width: 47.48,
    height: 6.274,
    transform: "translate(235.576 312.414)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1307",
    "data-name": "Rectangle 1307",
    width: 23.629,
    height: 6.274,
    transform: "translate(286.485 312.414)",
    fill: "#c3c640"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1308",
    "data-name": "Rectangle 1308",
    width: 59.723,
    height: 6.274,
    transform: "translate(314.203 312.414)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1309",
    "data-name": "Rectangle 1309",
    width: 27.495,
    height: 6.274,
    transform: "translate(196.902 324.286)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1310",
    "data-name": "Rectangle 1310",
    width: 22.342,
    height: 6.274,
    transform: "translate(233.639 324.286)",
    fill: "#c3c640"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1311",
    "data-name": "Rectangle 1311",
    width: 14.395,
    height: 6.274,
    transform: "translate(264.143 324.286)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1312",
    "data-name": "Rectangle 1312",
    width: 50.489,
    height: 6.274,
    transform: "translate(286.7 324.286)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1313",
    "data-name": "Rectangle 1313",
    width: 14.395,
    height: 6.274,
    transform: "translate(342.77 324.286)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1314",
    "data-name": "Rectangle 1314",
    width: 15.467,
    height: 6.274,
    transform: "translate(240.3 229.69)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2504",
    "data-name": "Path 2504",
    d: "M447.91,211.648a2.828,2.828,0,1,0,2.82-2.828A2.828,2.828,0,0,0,447.91,211.648Z",
    transform: "translate(-78.634 -36.66)",
    fill: "#c3c640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2505",
    "data-name": "Path 2505",
    d: "M461.28,211.648a2.828,2.828,0,1,0,2.828-2.828,2.828,2.828,0,0,0-2.828,2.828Z",
    transform: "translate(-80.981 -36.66)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2506",
    "data-name": "Path 2506",
    d: "M474.66,211.648a2.828,2.828,0,1,0,2.828-2.828A2.828,2.828,0,0,0,474.66,211.648Z",
    transform: "translate(-83.33 -36.66)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -2.05, 0)",
    filter: "url(#Rectangle_1315)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1315-2",
    "data-name": "Rectangle 1315",
    width: 272.107,
    height: 179.399,
    transform: "translate(75 93.01)",
    fill: "#fff3d9"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1316",
    "data-name": "Rectangle 1316",
    width: 267.375,
    height: 162.077,
    transform: "translate(75.28 106.435)",
    fill: "#352628"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1317",
    "data-name": "Rectangle 1317",
    width: 264.267,
    height: 159.538,
    transform: "translate(76.838 107.705)",
    fill: "#443637"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1318",
    "data-name": "Rectangle 1318",
    width: 10.52,
    height: 6.274,
    transform: "translate(96.476 119.874)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1319",
    "data-name": "Rectangle 1319",
    width: 59.508,
    height: 6.274,
    transform: "translate(111.308 119.874)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1320",
    "data-name": "Rectangle 1320",
    width: 38.889,
    height: 6.274,
    transform: "translate(180.907 119.874)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1321",
    "data-name": "Rectangle 1321",
    width: 39.961,
    height: 6.274,
    transform: "translate(106.361 131.029)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1322",
    "data-name": "Rectangle 1322",
    width: 36.35,
    height: 6.274,
    transform: "translate(149.842 143.568)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1323",
    "data-name": "Rectangle 1323",
    width: 36.35,
    height: 6.274,
    transform: "translate(193.455 143.568)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1324",
    "data-name": "Rectangle 1324",
    width: 6.579,
    height: 6.274,
    transform: "translate(235.988 143.568)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1325",
    "data-name": "Rectangle 1325",
    width: 10.536,
    height: 6.274,
    transform: "translate(247.679 143.568)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1326",
    "data-name": "Rectangle 1326",
    width: 54.999,
    height: 6.274,
    transform: "translate(209.054 131.029)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1327",
    "data-name": "Rectangle 1327",
    width: 45.971,
    height: 6.274,
    transform: "translate(153.627 131.029)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1328",
    "data-name": "Rectangle 1328",
    width: 54.999,
    height: 6.274,
    transform: "translate(118.827 154.492)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1329",
    "data-name": "Rectangle 1329",
    width: 15.895,
    height: 6.274,
    transform: "translate(118.827 165.952)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1330",
    "data-name": "Rectangle 1330",
    width: 27.924,
    height: 6.274,
    transform: "translate(141.598 165.952)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1331",
    "data-name": "Rectangle 1331",
    width: 21.048,
    height: 6.274,
    transform: "translate(181.122 165.952)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1332",
    "data-name": "Rectangle 1332",
    width: 21.048,
    height: 6.274,
    transform: "translate(207.339 165.952)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1333",
    "data-name": "Rectangle 1333",
    width: 27.495,
    height: 6.274,
    transform: "translate(137.303 177.824)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1334",
    "data-name": "Rectangle 1334",
    width: 88.512,
    height: 6.274,
    transform: "translate(168.236 177.824)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1335",
    "data-name": "Rectangle 1335",
    width: 27.495,
    height: 6.274,
    transform: "translate(118.827 189.704)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1336",
    "data-name": "Rectangle 1336",
    width: 13.743,
    height: 6.274,
    transform: "translate(151.475 189.704)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1337",
    "data-name": "Rectangle 1337",
    width: 48.988,
    height: 6.274,
    transform: "translate(172.531 189.704)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1338",
    "data-name": "Rectangle 1338",
    width: 15.038,
    height: 6.274,
    transform: "translate(140.741 201.584)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1339",
    "data-name": "Rectangle 1339",
    width: 6.447,
    height: 6.274,
    transform: "translate(160.923 201.584)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1340",
    "data-name": "Rectangle 1340",
    width: 16.753,
    height: 6.274,
    transform: "translate(175.54 201.584)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1341",
    "data-name": "Rectangle 1341",
    width: 39.961,
    height: 6.274,
    transform: "translate(197.025 201.584)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1342",
    "data-name": "Rectangle 1342",
    width: 20.191,
    height: 6.274,
    transform: "translate(242.567 201.584)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1343",
    "data-name": "Rectangle 1343",
    width: 61.866,
    height: 6.274,
    transform: "translate(267.919 201.584)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1344",
    "data-name": "Rectangle 1344",
    width: 27.495,
    height: 6.274,
    transform: "translate(140.741 213.456)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1345",
    "data-name": "Rectangle 1345",
    width: 18.476,
    height: 6.274,
    transform: "translate(176.826 213.456)",
    fill: "#c3c640"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1346",
    "data-name": "Rectangle 1346",
    width: 18.476,
    height: 6.274,
    transform: "translate(202.607 213.456)",
    fill: "#c3c640"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1347",
    "data-name": "Rectangle 1347",
    width: 69.171,
    height: 6.274,
    transform: "translate(140.741 225.337)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1348",
    "data-name": "Rectangle 1348",
    width: 36.515,
    height: 6.274,
    transform: "translate(215.93 225.337)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1349",
    "data-name": "Rectangle 1349",
    width: 27.495,
    height: 6.274,
    transform: "translate(118.827 237.217)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1350",
    "data-name": "Rectangle 1350",
    width: 19.77,
    height: 6.274,
    transform: "translate(153.627 237.217)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1351",
    "data-name": "Rectangle 1351",
    width: 47.48,
    height: 6.274,
    transform: "translate(179.407 237.217)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1352",
    "data-name": "Rectangle 1352",
    width: 23.629,
    height: 6.274,
    transform: "translate(230.324 237.217)",
    fill: "#c3c640"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1353",
    "data-name": "Rectangle 1353",
    width: 59.723,
    height: 6.274,
    transform: "translate(258.034 237.217)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1354",
    "data-name": "Rectangle 1354",
    width: 27.495,
    height: 6.274,
    transform: "translate(140.741 249.089)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1355",
    "data-name": "Rectangle 1355",
    width: 22.342,
    height: 6.274,
    transform: "translate(177.469 249.089)",
    fill: "#c3c640"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1356",
    "data-name": "Rectangle 1356",
    width: 14.395,
    height: 6.274,
    transform: "translate(207.974 249.089)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1357",
    "data-name": "Rectangle 1357",
    width: 50.489,
    height: 6.274,
    transform: "translate(230.531 249.089)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1358",
    "data-name": "Rectangle 1358",
    width: 14.395,
    height: 6.274,
    transform: "translate(286.601 249.089)",
    fill: "#fff3d9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1359",
    "data-name": "Rectangle 1359",
    width: 15.467,
    height: 6.274,
    transform: "translate(184.131 154.492)",
    fill: "#ff5240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2507",
    "data-name": "Path 2507",
    d: "M379.78,120.4a2.828,2.828,0,1,0,2.82-2.828,2.828,2.828,0,0,0-2.82,2.828Z",
    transform: "translate(-66.673 -20.64)",
    fill: "#c3c640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2508",
    "data-name": "Path 2508",
    d: "M393.15,120.4a2.828,2.828,0,1,0,2.828-2.828A2.828,2.828,0,0,0,393.15,120.4Z",
    transform: "translate(-69.021 -20.64)",
    fill: "#ffcd50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2509",
    "data-name": "Path 2509",
    d: "M406.54,120.4a2.828,2.828,0,1,0,2.82-2.828A2.828,2.828,0,0,0,406.54,120.4Z",
    transform: "translate(-71.371 -20.64)",
    fill: "#ff5240"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyAndPaste);
export default __webpack_public_path__ + "static/media/copy-and-paste.1105e3b532373ab2c2288af4da7df20f.svg";
export { ForwardRef as ReactComponent };